import { useContext } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { AreaContext } from "../store/AreaContext";
import { FADE, PLAY, SAVE_DESTINATION } from "../store/AreaReducers";
import LabelledButton from "./LabelledButton";

export default function TransitionLabelledButton({
  to,
  forceFade = false,
  ...props
}) {
  const history = useHistory();
  const { dispatchTransition, currentArea, dispatchDestination } =
    useContext(AreaContext);

  const transitionOutUrl =
    currentArea?.transition_out?.url ||
    "";
  const backgroundMime =
    currentArea?.background?.mime ||
    "";

  const handleClick = () => {
    dispatchDestination({
      type: SAVE_DESTINATION,
      payload: {
        to,
        transition_url: forceFade ? null : transitionOutUrl,
      },
    });

    if (forceFade) {
      dispatchTransition({
        type: FADE,
        payload: to,
      });
      return;
    }

    if (!currentArea?.background || backgroundMime.includes("image")) {
      dispatchTransition({
        type: PLAY,
        payload: {
          url: transitionOutUrl,
          to,
        },
      });
      return;
    }

    history.push(to);
  };

  return <LabelledButton {...props} onClick={handleClick} />;
}
